"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segmented = Segmented;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 16 Oct 2026 · Two or three ways of looking at the same thing.             │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * *Heti / Havi* on Időrögzítés, *Nap / Hét / Hónap* and *Kumulatív / Időszakos* on the finance
 * chart. The mockups draw it identically everywhere — a muted track, 24 px buttons, the chosen
 * one lifted onto the background — and the product had grown a private copy per screen. The
 * design system has no component for it, so the mockup's own drawing is the specification.
 *
 * ⚠️ **`aria-pressed` buttons in a `group`, not tabs.** Tabs own a panel each; this changes how
 * ONE panel is drawn, which is a pressed toggle.
 */
function Segmented({ value, options, onChange, label, className, }) {
    return ((0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": label, className: (0, cn_1.cn)('bg-muted flex shrink-0 items-center gap-0.5 rounded-md p-0.5', className), "data-segmented": true, children: options.map((option) => ((0, jsx_runtime_1.jsx)("button", { type: "button", "aria-pressed": value === option.value, className: (0, cn_1.cn)('h-6 rounded px-2 text-[11.5px] font-medium transition-colors', value === option.value
                ? 'bg-background text-foreground shadow-xs'
                : 'text-muted-foreground hover:text-foreground'), onClick: () => {
                onChange(option.value);
            }, children: option.label }, option.value))) }));
}
//# sourceMappingURL=segmented.js.map